import { type FunctionComponent } from 'react';
import { type FindCustomerFieldsFragment } from '../../../__generated__/graphql-client-types';
import { handleKeys } from '../../../helpers/keyboard/keyboard.helper';

export type CustomerListProps = {
	searchResults: FindCustomerFieldsFragment[];
	onSelectCustomer?: (customerId: number) => void;
};

const CustomerListItem: FunctionComponent<{ customer: FindCustomerFieldsFragment; customerSelect?: (customerId: number) => void }> = ({
	customer,
	customerSelect
}) => {
	const selectCustomer = () => {
		if (customerSelect) {
			customerSelect(customer.id);
		}
	};
	return (
		<li className={'hover-bg-theme-grey-lighter lh-copy f5 pa2-ns mb3 bb b--theme-grey-light pointer'}>
			<div
				onClick={selectCustomer}
				onKeyDown={handleKeys(['Enter', ' '], selectCustomer)}
				role="button"
				tabIndex={0}
				data-testid={`search-customer-${customer.id}`}>
				<div>
					<strong>Order Count: </strong> <span className="theme-error">{customer.orderCount}</span>
				</div>
				<div data-testid="lastOrderDate">
					<strong>Last Order Date: </strong>
					<span className="theme-error">
						{customer.lastOrderDate ? new Date(customer.lastOrderDate).toLocaleString() : 'NEVER'}
					</span>
				</div>
				<div className="flex mt2">
					<div className="w-50">
						<strong>Billing Address</strong>
						<ul className="list pl0">
							<li>
								{customer.firstName} {customer.lastName}
							</li>
							<li>{customer.billingAddress.address}</li>
							<li>{customer.billingAddress.address2}</li>
							<li>
								{customer.billingAddress.city}, {customer.billingAddress.state.name} {customer.billingAddress.zipCode}
							</li>
						</ul>
					</div>
					<div className="w-50">
						<strong>Account Info</strong>
						<ul className="list pl0">
							<li>Email: {customer.email}</li>
							<li>UserDBID: {customer.id}</li>
						</ul>
					</div>
				</div>
			</div>
		</li>
	);
};

export const CustomerList: FunctionComponent<CustomerListProps> = ({ searchResults, onSelectCustomer }) => {
	return (
		<ul className={'pa0 pa3-ns list'}>
			{searchResults.map((result) => (
				<CustomerListItem key={result.id} customer={result} customerSelect={onSelectCustomer} />
			))}
		</ul>
	);
};
